import $ from 'jquery'

export const WL_SUCCESS = 0
export const WL_FAIL = 1
export const WL_EXCEPTION = 2
export const WL_UNAUTHORIZED = 3



var WebApiServer = ""

export function WL_SetHost(host) {
    WebApiServer = host
}

function WL_Login(token,username, password, authtoken, fResult) {
    let user = { token, username, password, authtoken }
    $.post(WebApiServer +"api/login", user)
        .done(function (userInfo, status) {
            if (status === "success") {
                if (userInfo["token"] === '00000000-0000-0000-0000-000000000000') {
                    console.log("Login Failed")
                    fResult(WL_FAIL)
                }
                else {
                    fResult(WL_SUCCESS, { username:userInfo.username, userInfo })
                }
            }
        })
        .fail(function (xhr, status, error) {
            fResult(WL_EXCEPTION)
        })
}
function WL_LoginDummy(token, username, password, authtoken, fResult) {
    if (username === "dummy") {
        fResult(WL_SUCCESS, { username, userInfo: { token: '11111111-2222-3333-4444-555555555555', userFullName:'Dummy User', code:'DMY'} })
    } else {
        fResult(WL_FAIL)
    }
}


function WL_GetLogs(token, fResult) {
    $.ajaxSetup({ cache: false })
    $.get(WebApiServer +"api/loggings/" + token)
        .done(function (data, status) {
            if (status === "success") {
                fResult(WL_SUCCESS, data)
            }
            else {
                fResult(WL_FAIL)
            }
        })
        .fail(function (xhr, status, error) {
            if (error === 'Unauthorized')
                fResult(WL_UNAUTHORIZED)
            else
                fResult(WL_EXCEPTION)
        })
}
function WL_GetLogsDummy(token, fResult) {
    fResult(WL_SUCCESS, {
        start: '1/1/2020',
        end:'1/1/2021',
        logs: [
            {
                project_nameField: "project1",
                project_idField: 10,
                project_item_idField: 110,
                durationField: 1,
                locationField: 'thuis',
                distanceField:'100',
                descriptionField:'commentaartje',
                dateField:'3/3/2020',
                project_item_nameField:'deeltaak1',
                logging_idField: '10000'
            },
            
        ]
    })
}

function WL_AddLogs(token, log, fResult) {
    let formDataAddLog = { token, log }
    $.post(WebApiServer +"api/loggings", formDataAddLog)
        .done(function (data, status) {
            //console.log("Add log result:" + status)
            if (status === "success") {
                fResult(WL_SUCCESS)
            }
            else {
                fResult(WL_FAIL)
            }
        })
        .fail(function (xhr, status, error) {
            //console.log("error:" + error)
            if (error === 'Unauthorized')
                fResult(WL_UNAUTHORIZED)
            else
                fResult(WL_EXCEPTION)
        });
}
function WL_AddLogsDummy(token, log, fResult) {
    fResult(WL_SUCCESS)
}
function WL_UpdateLog(token, log, fResult) {
    let formDataAddLog = { token, log }
    $.post(WebApiServer +"api/loggings", formDataAddLog)
        .done(function (data, status) {
            //console.log("Add log result:" + status)
            if (status === "success") {
                fResult(WL_SUCCESS)
            }
            else {
                fResult(WL_FAIL)
            }
        })
        .fail(function (xhr, status, error) {
            if (error === 'Unauthorized')
                fResult(WL_UNAUTHORIZED)
            else
                fResult(WL_EXCEPTION)
        });
}

function WL_UpdateLogDummy(token, log, fResult) {
    fResult(WL_SUCCESS)
}

function WL_DeleteLog(token, log, fResult) {

    let formDataAddLog = { token, log }

    $.ajax({
        url: WebApiServer +"api/loggings", method: "DELETE", data: formDataAddLog })
        .then(function (data, status) {
            if (status === "success") {
                console.log("DELETE OK")
                fResult(WL_SUCCESS)
            }
            else {
                console.log("DELETE FAIL")
                fResult(WL_FAIL)
            }
        })
        .catch(function (xhr, status, error) {
            if (error === 'Unauthorized') {
                console.log("DELETE UNAUTH")
                fResult(WL_UNAUTHORIZED)
            }
            else {
                console.log("DELETE EXCEPTION")
                fResult(WL_EXCEPTION)
            }
        });
   
}
function WL_DeleteLogDummy(token, log, fResult) {
    fResult(WL_SUCCESS)
}

function WL_GetProjects(token, type, fResult, cbData) {

    $.post(WebApiServer +"api/projects", { token, type })
        .done(function (data, status) {
            //console.log("Get Projects result:"+status)
            if (status === "success") {
                fResult(WL_SUCCESS, data, cbData)
            }
            else {
                fResult(WL_FAIL)
            }
        })
        .fail(function (xhr, status, error) {
            if (error === 'Unauthorized')
                fResult(WL_UNAUTHORIZED)
            else
                fResult(WL_EXCEPTION)
        });
}
function WL_GetProjectsDummy(token, type, fResult, cbData) {
    fResult(WL_SUCCESS, [
        { id: 10, name: 'project 1', regie: true, done: 5, budget: 4, showLogsInHours: false, logCommentsRequired: true },
        { id: 11, name: 'project 2', regie: false, done: 15, budget: 14, showLogsInHours: true, logCommentsRequired: false },

    ]
    , cbData)
}

function WL_GetProjectItems(token, projectId, fResult) {
    $.post(WebApiServer +"api/projectitems" , { token, projectId })
        .done(function (data, status) {
            if (status === "success") {
                fResult(WL_SUCCESS, data)
            }
            else {
                fResult(WL_FAIL)
            }
        })
        .fail(function (xhr, status, error) {
            if (error === 'Unauthorized')
                fResult(WL_UNAUTHORIZED)
            else
                fResult(WL_EXCEPTION)
        })
}
function WL_GetProjectItemsDummy(token, projectId, fResult) {
    fResult(WL_SUCCESS, [
        { id: 110, name: "deeltaak1", done: '5', budget: 10, showLogsInHours: true },
        { id: 111, name: "deeltaak2", done: '3', budget: 12, showLogsInHours: true }
    ])
}

function WL_OpenReport(token, type, startDate, endDate, projectId) {
    if (projectId === undefined) projectId = 0

    const url =
        WebApiServer +
        "api/report?type=" + encodeURIComponent(type) +
        "&start=" + encodeURIComponent(startDate.format("YYYY-MM-DD")) +
        "&end=" + encodeURIComponent(endDate.format("YYYY-MM-DD")) +
        "&projectid=" + encodeURIComponent(projectId)

    // Open tab immediately to avoid popup blockers
    const reportWindow = window.open("", "_blank")

    fetch(url, {
        method: "GET",
        headers: {
            token: token
        }
    })
        .then(response => {
            if (response.status === 401) throw new Error("UNAUTHORIZED")
            if (!response.ok) throw new Error("HTTP_" + response.status)
            return response.blob()
        })
        .then(blob => {
            const blobUrl = URL.createObjectURL(blob)
            if (reportWindow) {
                reportWindow.location = blobUrl
            } else {
                window.open(blobUrl, "_blank")
            }
            setTimeout(() => URL.revokeObjectURL(blobUrl), 60000)
        })
        .catch(() => {
            if (reportWindow) reportWindow.close()
            alert("Failed to open report.")
        })
}
function WL_OpenReportDummy(token, type, startDate, endDate) {
    console.log("Dummy Dummy")
}

function WL_GetJobDayInfo(token, fResult, cbData) {
    console.log("getting jdis")
    $.ajaxSetup({ cache: false })
    $.get(WebApiServer + "api/jobdayinfo/", { token })
        .done(function (data, status) {
            if (status === "success") {
                fResult(WL_SUCCESS, data, cbData)
            }
            else {
                fResult(WL_FAIL)
            }
        })
        .fail(function (xhr, status, error) {
            if (error === 'Unauthorized')
                fResult(WL_UNAUTHORIZED)
            else
                fResult(WL_EXCEPTION)
        })
}
function WL_GetJobDayInfoDummy(token, fResult, cbData) {
    fResult(WL_SUCCESS, 
        [
            {
                periodFrom: '1/1/2020',
                periodTill: '1/1/2021',
                workingRegime:8
            },
        ]
    )
}

const dummyImpl = {
    OpenReport: WL_OpenReportDummy,
    GetProjectItems: WL_GetProjectItemsDummy,
    GetProjects: WL_GetProjectsDummy,
    DeleteLog: WL_DeleteLogDummy,
    UpdateLog: WL_UpdateLogDummy,
    AddLogs: WL_AddLogsDummy,
    GetLogs: WL_GetLogsDummy,
    Login: WL_LoginDummy,
    GetJobDayInfo: WL_GetJobDayInfoDummy
}
const liveImpl = {
    OpenReport: WL_OpenReport,
    GetProjectItems: WL_GetProjectItems,
    GetProjects: WL_GetProjects,
    DeleteLog: WL_DeleteLog,
    UpdateLog: WL_UpdateLog,
    AddLogs: WL_AddLogs,
    GetLogs: WL_GetLogs,
    Login: WL_Login,
    GetJobDayInfo: WL_GetJobDayInfo
}
const dummy = false
const WL = dummy ? dummyImpl : liveImpl
export {WL}
